import $ from 'jquery';
import { Functions } from '../helpers';

export class FormsFloating {

	constructor( App ) {
		FormsFloating.App      = App;
		FormsFloating.UI       = App.PwnUI;
		FormsFloating.settings = App.settings;
        this.$element          = $( '.js-pwn-c-sbox-input-field' );
		this.initialize();
	};

	initialize() {
       if ( !  this.$element.length ) return;

        // trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
        if ( ! String.prototype.trim ) {
            ( function() {
                // Make sure we trim BOM and NBSP
                var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
                String.prototype.trim = function() {
                    return this.replace( rtrim, '' );
                };
            } ) ();
        }

         this.$element.each( function( index, el ) {
            if ( $( this ).val().trim() !== '' ) {
                $( this ).parent().addClass( 'c-sbox-input-filled' );
            }
            $( this ).trigger( 'change' );
        } );

         this.$element.on( 'focus', this.onFocus );
         this.$element.on( 'blur', this.onBlur );
         this.$element.on( 'change', this.onChange );
	};

	onFocus( e ) {
        $( e.target ).closest('.c-sbox-input').addClass( 'c-sbox-input-filled' );
    };

    onBlur( e ) {
        if ( $( e.target ).val().trim() === '' ) {
            $( e.target ).closest('.c-sbox-input').removeClass( 'c-sbox-input-filled' );
        }
    };

    onChange( e ) {
        $( e.target ).closest('.c-sbox-input').addClass( 'c-sbox-input-filled' );
    };
}
